<mat-horizontal-stepper #stepper labelPosition="bottom">
    <mat-step editable="true">
        <div class="container">
            <div class="content">
                <h1 class="mat-display-2">Willkommen</h1>
                <p class="mat-title">bei</p>
                <img src="https://dev.stage.dave-cc.com/assets/images/logo.svg" alt="c2go"/>
                <p class="mat-title" *ngIf="Theme.HasTheme$ | async">und unserem Kooperationspartner</p>
                <img [src]="Theme.Logo$|async" *ngIf="Theme.HasTheme$ | async" [alt]="Theme.Name$|async"/>
                <p class="mat-subheading-3">
                    Wir benötigen einige Berechtigungen. Mit dem Klicken auf "Weiter" bestätigen Sie unsere
                    <b><a href="https://c2c-erp.de/storage/app/media/2022-10-30_AGB-c2c.pdf" target="_blank">AGB</a></b> und
                    <b><a href="https://c2c-erp.de/storage/app/media/2022-10-30_Datenschutz-c2c.pdf" target="_blank">Datenschutzbestimmungen</a></b>.
                </p>
            </div>
            <div class="buttons">
                <div></div>
                <button mat-raised-button color="primary" matStepperNext>
                    Weiter
                    <fa-icon icon="chevron-right"></fa-icon>
                </button>
            </div>
        </div>
    </mat-step>
    <mat-step [stepControl]="PermissionsForm" [editable]="PermissionsForm.valid">
        <div class="container">
            <h1 class="mat-display-2">Berechtigungen</h1>
            <div class="content">
                <fa-icon icon="lock" size="10x" *ngIf="PermissionsForm.invalid"></fa-icon>
                <fa-icon icon="unlock" size="10x" *ngIf="PermissionsForm.valid"></fa-icon>
                <p class="mat-subheading-2">
                    c2go möchte auf Ihre Kamera und Mikrofon zugreifen.
                </p>
                <button mat-raised-button color="primary" (click)="requestPermission()">
                    <span *ngIf="!loading">Gewähren</span>
                    <fa-icon icon="spinner" size="1x" [spin]="true" *ngIf="loading"></fa-icon>
                </button>
            </div>
            <div class="buttons">
                <button mat-raised-button color="primary" matStepperPrevious>
                    <fa-icon icon="chevron-left"></fa-icon>
                    Zurück
                </button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="PermissionsForm.invalid">Weiter
                    <fa-icon icon="chevron-right"></fa-icon>
                </button>
            </div>
        </div>
    </mat-step>
    <mat-step [stepControl]="CameraForm" [editable]="CameraForm.valid">
        <div class="container">
            <h1 class="mat-display-2">Kamera</h1>
            <div class="content">
                <fa-icon icon="camera" size="10x"></fa-icon>
                <p class="mat-subheading-2">
                    Wir empfehlen Ihnen im unten stehenden Menü die Rückkamera auszuwählen.
                </p>
                <mat-form-field appearance="fill">
                    <mat-label>Kamera</mat-label>
                    <mat-select [formControl]="CameraForm.controls.Camera">
                        <mat-option *ngFor="let camera of (Cameras$ | async)" [value]="camera.deviceId">
                            {{camera.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="buttons">
                <button mat-raised-button color="primary" matStepperPrevious>
                    <fa-icon icon="chevron-left"></fa-icon>
                    Zurück
                </button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="CameraForm.invalid">Weiter
                    <fa-icon icon="chevron-right"></fa-icon>
                </button>
            </div>
        </div>
    </mat-step>
    <mat-step [stepControl]="MicrophoneForm" [editable]="MicrophoneForm.valid">
        <div class="container">
            <h1>Mikrofon</h1>
            <div class="content">
                <fa-icon icon="microphone" size="10x"></fa-icon>
                <p class="mat-subheading-2">
                    Bitte wählen Sie ein Mikrofon aus.
                </p>
                <mat-form-field appearance="fill">
                    <mat-label>Mikrofon</mat-label>
                    <mat-select [formControl]="MicrophoneForm.controls.Microphone">
                        <mat-option *ngFor="let microphone of (Microphones$ | async)" [value]="microphone.deviceId">
                            {{microphone.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="buttons">
                <button mat-raised-button color="primary" matStepperPrevious>
                    <fa-icon icon="chevron-left"></fa-icon>
                    Zurück
                </button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="MicrophoneForm.invalid">
                    Weiter
                    <fa-icon icon="chevron-right"></fa-icon>
                </button>
            </div>
        </div>
    </mat-step>
    <mat-step [stepControl]="SpeakersForm" [editable]="SpeakersForm.valid" *ngIf="SpeakerSetEnabled">
        <div class="container">
            <h1>Lautsprecher</h1>
            <div class="content">
                <fa-icon icon="volume-up" size="10x"></fa-icon>
                <p class="mat-subheading-2">
                    bitte wählen Sie ihren Lautsprecher aus.
                </p>
                <mat-form-field appearance="fill">
                    <mat-label>Lautsprecher</mat-label>
                    <mat-select [formControl]="SpeakersForm.controls.Speaker">
                        <mat-option *ngFor="let speaker of (Speakers$ | async)" [value]="speaker.deviceId">
                            {{speaker.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="buttons">
                <button mat-raised-button color="primary" matStepperPrevious>
                    <fa-icon icon="chevron-left"></fa-icon>
                    Zurück
                </button>
                <button mat-raised-button color="primary" matStepperNext [disabled]="MicrophoneForm.invalid">
                    Weiter
                    <fa-icon icon="chevron-right"></fa-icon>
                </button>
            </div>
        </div>
    </mat-step>
    <mat-step editable="false">
        <div class="container">
            <h1>Fertig</h1>
            <div class="content">
                <fa-icon icon="check" size="10x"></fa-icon>
                <br>
<!--                <p class="mat-subheading-2">-->
<!--                    bitte wählen Sie ihren Lautsprecher aus.-->
<!--                </p>-->
                <button mat-raised-button color="primary" (click)="Finish()">
                    Abschließen
                </button>
            </div>
            <div class="buttons">
                <button mat-raised-button color="primary" matStepperPrevious>
                    <fa-icon icon="chevron-left"></fa-icon>
                    Zurück
                </button>
            </div>
        </div>
    </mat-step>
</mat-horizontal-stepper>
